import {z} from 'zod';

export const ReferenceIdSchema = z
  .string()
  .min(3)
  .regex(/^[a-z0-9_.-]+$/u, {message: 'errorReferenceId'})
  .describe('Allowed characters: lowercase letters, numbers, dot, dash and underscore');
export type ReferenceId = z.infer<typeof ReferenceIdSchema>;
